export default "__VITE_ASSET__0baa8608__"